import React from 'react';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux';
import { notesPendingActionActions, patientActions } from '_actions';
import {
    PatientDot,
    EditNoteButton,
    PatientCareCenterButton,
    LoadingIcon,
    TrashButton
} from '_components'
import messageCenterCommonStyles from 'MessageCenter/Common.module.css'
import styles from './Details.module.css'

class NotesPendingActionDetails extends React.Component {

    editNote() {
        this.props.editNote(this.props.message.ptno, this.props.message.id, this.props.message.epno);
    }

    render() {
        var options = { year: '2-digit', month: 'numeric', day: 'numeric' };
        let pteroNoteTypes = [1, 2, 3, 4, 5, 6];
        let rejectionTypes = [2, 4, 6];
        let approvalTypes = [1, 3, 5];

        if (this.props.message)
            return (
                <div className={messageCenterCommonStyles.message_center_details_wrapper} >
                    <div className={messageCenterCommonStyles.message_header}>Notes Pending Action: {this.props.message.ptname + " - " + (this.props.noteType ? this.props.noteType.MTABBREV : "") + " " + new Date(this.props.message.noteDate).toLocaleDateString("en-US", options)}</div>
                    <hr className={messageCenterCommonStyles.message_header_separator} />

                    <div className={styles.details_table}>
                        <div className={styles.details_cell} >
                            <div className={styles.labels}>
                                <div>Patient:</div>
                                <div>Admission:</div>
                                <div>DOS:</div>
                                <div>Type:</div>
                            </div>
                            <div className={styles.data}>
                                <div className={this.props.message.isFederal ? styles.italic : ''}><span className={styles.patient_dot}><PatientDot id={this.props.message.dot} /></span>{' ' + this.props.message.ptname + ' (SYS#' + this.props.message.ptno + ')'}</div>
                                <div>{this.props.message.admissionDesc + ' - ' + this.props.message.discipline + ' - ' + this.props.message.locationName}</div>
                                <div>{new Date(this.props.message.noteDate).toLocaleDateString("en-US", options) + ' (visit ' + this.props.message.visitNum + ')'}</div>
                                <div>{(this.props.noteType ? this.props.noteType.MTABBREV : "")}</div>
                            </div>
                        </div>
                        <div className={styles.button_wrapper}>
                            <div className={styles.button_div}>
                                {approvalTypes.includes(this.props.message.notificationType) &&
                                    <span className={styles.button}><TrashButton onClick={() => this.props.deleteMsg(this.props.message.NONO)} /></span>
                                }
                                {rejectionTypes.includes(this.props.message.notificationType) && pteroNoteTypes.includes(this.props.message.noteType) &&
                                    <span className={styles.button}><EditNoteButton onClick={() => this.editNote()} /></span>
                                }
                                <span className={styles.button}><PatientCareCenterButton ptno={this.props.message.ptno} /></span>
                            </div>
                        </div>
                    </div>

                    <div className={styles.wrapper}>

                        {approvalTypes.includes(this.props.message.notificationType) &&
                            <div className={styles.message_wrapper} >
                                <div className={styles.message_header} >{new Date(this.props.message.finalDate).toLocaleString("en-US") + " - Approved by " + this.props.message.supvName}</div>
                                <div className={styles.message_content} />
                            </div>
                        }

                        {this.props.messageHistory && this.props.messageHistory.length > 0 ? Object.keys(this.props.messageHistory)
                            .map(key => {
                                const historyEntry = this.props.messageHistory[key];
                                return <div key={historyEntry.id} className={styles.message_wrapper} >
                                    <div className={styles.message_header} >{new Date(historyEntry.msgDate).toLocaleString("en-US") + " - " + historyEntry.msgType + " by " + historyEntry.msgUser}</div>
                                    <div className={styles.message_content} >{historyEntry.details}</div>
                                </div>
                            }) : <span />
                        }
                    </div>


                </div>
            );
        else
            return (
                <div className={messageCenterCommonStyles.message_center_details_wrapper} >
                    <div className={messageCenterCommonStyles.message_header}>Notes Pending Action</div>
                    <hr className={messageCenterCommonStyles.message_header_separator} />
                    {this.props.loading === true ?
                        <LoadingIcon size="small" />
                        : <div className={styles.italic}>No Message Selected</div>
                    }
                </div>
            );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        deleteMsg: bindActionCreators(notesPendingActionActions.delete, dispatch),
        editNote: bindActionCreators(patientActions.openEditNote, dispatch)
    };
}

function mapStateToProps(state) {
    let message = state.entities.notesPendingAction[state.ui.notesPendingAction.selectedMessage];
    let noteType = state.ui.notesPendingAction.selectedMessage &&
        state.entities.notesPendingAction[state.ui.notesPendingAction.selectedMessage].noteType ?
        state.entities.masterData.PTMASTERNOTETYPES[state.entities.notesPendingAction[state.ui.notesPendingAction.selectedMessage].noteType]
        : undefined;
    let messageHistory = message ? Object.keys(state.entities.notesPendingActionMsgs)
        .filter(key => { return state.entities.notesPendingActionMsgs[key].noteId === state.entities.notesPendingAction[state.ui.notesPendingAction.selectedMessage].id; })
        .sort((a, b) => new Date(state.entities.notesPendingActionMsgs[b].msgDate) - new Date(state.entities.notesPendingActionMsgs[a].msgDate))
        .map(key => state.entities.notesPendingActionMsgs[key])
        : undefined;

    return {
        message,
        noteType,
        loading: state.ui.notesPendingAction.loading,
        messageHistory
    };
}


const connectedNotesPendingActionDetails = connect(mapStateToProps, mapDispatchToProps)(NotesPendingActionDetails);
export { connectedNotesPendingActionDetails as NotesPendingActionDetails };
